import axios from 'axios';

export const url = {
  local: 'http://192.241.48.14:4000/',
  localCasa: 'http://192.168.15.6:5000/',
  producao: 'https://app.dcsautomacao.com.br:4117/',
  socket: 'http://192.168.1.33:3001',
}

export default axios.create({
  baseURL: url.producao
});

